<div class="di-liste-facture__container">
	<div *ngIf="mode === 'edit'">
		<div *ngIf="factures.length > 0">
			<ng-container *ngFor="let facture of factures">
				<div class="di-liste-facture__item" id="{{facture.invoiceNumber}}">
					<p>{{facture.invoiceType | firstUpperCase}} n° {{facture.invoiceNumber}}</p>
					<lua-bouton-icone *ngIf="facture.securisationMode === 'DEGRADE' || facture.securisationMode === 'PAPIER'"
						iconName="task" mode="filled" (onClick)="handelOpenFsp(facture,$event)"></lua-bouton-icone>
					<lua-bouton-icone iconName="invoice-euro" [isIcon]="true" mode="outlined"
						(onClick)="handelOpenFacture(facture,$event)"></lua-bouton-icone>
				</div>
			</ng-container>
		</div>
	</div>
	<ng-container *ngIf="factures.length === 0">
		<lua-message-aucune-donnee mainText="Aucune facture" iconName="contract" buttonLabel="Retour"
			(onClick)="goBack($event)"></lua-message-aucune-donnee>
	</ng-container>
</div>